module.exports = __webpack_public_path__ + "static/media/NEDBANK-Logo.ade418a3.png";